import { AbstractControl, ValidationErrors, ValidatorFn, FormGroup } from '@angular/forms';

/**
 * Custom validator to prevent duplicate emails across roles
 * and within authors.
 */
export function noDuplicateEmailsValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    if (!(group instanceof FormGroup)) return null;

    const ownerCtrl = group.get('ownerEmail');
    const deputyCtrl = group.get('deputyEmail');
    const authorCtrl = group.get('authorEmails');

    if (!ownerCtrl || !deputyCtrl || !authorCtrl) return null;

    const owner = ownerCtrl.value?.trim()?.toLowerCase();
    const deputy = deputyCtrl.value?.trim()?.toLowerCase();
    const authors: string[] = (authorCtrl.value || []).map((a: string) => a.trim().toLowerCase());

    // Clear previous duplicateRole errors
    clearDuplicateError(ownerCtrl);
    clearDuplicateError(deputyCtrl);
    clearDuplicateError(authorCtrl);

    let hasError = false;

    // Cross-role duplicates

    // Owner ↔ Deputy
    if (owner && deputy && owner === deputy) {
      setDuplicateError(ownerCtrl);
      setDuplicateError(deputyCtrl);
      hasError = true;
    }

    // Owner ↔ Authors
    if (owner && authors.includes(owner)) {
      setDuplicateError(ownerCtrl);
      setDuplicateError(authorCtrl);
      hasError = true;
    }

    // Deputy ↔ Authors
    if (deputy && authors.includes(deputy)) {
      setDuplicateError(deputyCtrl);
      setDuplicateError(authorCtrl);
      hasError = true;
    }

    //Internal duplicates within authors 
    const authorSet = new Set(authors);
    if (authors.length !== authorSet.size) {
      setDuplicateError(authorCtrl);
      hasError = true;
    }

    return hasError ? { duplicateEmails: true } : null;
  };
}

//Helper functions
function setDuplicateError(control: AbstractControl) {
  control.setErrors({
    ...control.errors,
    duplicateRole: true
  });
}

function clearDuplicateError(control: AbstractControl) {
  if (!control.errors) return;

  const { duplicateRole, ...otherErrors } = control.errors;
  control.setErrors(Object.keys(otherErrors).length ? otherErrors : null);
}